export const getBusinessVoicesUrl = (locationId?: string, agentId?: string) =>
  `/business/locations/${locationId}/agents/${agentId}/voices`;

export const getBusinessVoiceUrl = (id?: string, locationId?: string, agentId?: string) =>
  `/business/locations/${locationId}/agents/${agentId}/voices/${id}`;

export const getBusinessVoiceCreationUrl = (locationId?: string, agentId?: string) =>
  `/business/locations/${locationId}/agents/${agentId}/voices`;

export const getBusinessLanguageAccentsUrl = (code?: string, locationId?: string, agentId?: string) =>
  `/business/locations/${locationId}/agents/${agentId}/languages/${code}/accents`;
